module.exports = __webpack_public_path__ + "assets/icon-next.c48d6d4c.svg";